<app-portal-layout>
  <div class="p-8 md:mt-0 md:p-16 md:pt-8 flex-1 flex flex-col">
    <h1 class="font-bold text-3xl md:text-5xl">Vamos al grano</h1>
    <p class="mt-4 md:text-2xl">
      Llena estos datos para validar tu info. Es rápido. Es fácil. Es por ti
    </p>
    <form
      [formGroup]="activationForm"
      (ngSubmit)="onSubmit()"
      class="space-y-6 flex flex-col flex-1 mt-4 md:grid md:grid-cols-2 gap-2 md:mt-12"
    >
      <mat-form-field>
        <mat-label class="md:text-xl">Tipo de documento</mat-label>
        <mat-select formControlName="documentType">
          @for (item of documentType; track $index) {
            <mat-option [value]="item.value">{{ item.name }}</mat-option>
          }
        </mat-select>
        @if (
          activationForm.get("documentType")?.invalid &&
          (activationForm.get("documentType")?.dirty ||
            activationForm.get("documentType")?.touched)
        ) {
          <mat-error>El tipo de documento es requerido</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label class="md:text-xl">Número de documento</mat-label>
        <input type="number" formControlName="id" matInput />
        <mat-hint>solo números sin . , </mat-hint>
        @if (
          activationForm.get("id")?.invalid &&
          (activationForm.get("id")?.dirty || activationForm.get("id")?.touched)
        ) {
          @if (activationForm.get("id")?.getError("required")) {
            <mat-error>El documento es requerido</mat-error>
          }
          @if (activationForm.get("id")?.getError("maxLength")) {
            <mat-error>10 números máximo</mat-error>
          }
        }
      </mat-form-field>
      @if (activationForm.get("documentType")?.value !== "NIT") {
        <mat-form-field>
          <mat-label class="md:text-xl">Fecha de expedición</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            [max]="maxDate"
            formControlName="expeditionDate"
          />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (
            activationForm.get("expeditionDate")?.invalid &&
            (activationForm.get("expeditionDate")?.dirty ||
              activationForm.get("expeditionDate")?.touched)
          ) {
            <mat-error>Fecha de expedición es obligatoria.</mat-error>
          }
        </mat-form-field>
      }

      <mat-form-field>
        <mat-label class="md:text-xl">Correo Electrónico</mat-label>
        <input type="text" formControlName="email" matInput />
        @if (
          activationForm.get("email")?.invalid &&
          (activationForm.get("email")?.dirty ||
            activationForm.get("email")?.touched)
        ) {
          @if (activationForm.get("email")?.getError("required")) {
            <mat-error>El correo electrónico es obligatorio</mat-error>
          }
          @if (activationForm.get("email")?.getError("email")) {
            <mat-error>El correo electrónico tiene formato inválido</mat-error>
          }
        }
      </mat-form-field>
    </form>
    @if (isLoading) {
      <div class="w-full flex justify-center p-4">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
      <div class="flex gap-4 md:justify-center">
        <button
          type="button"
          class="bg-white w-[169px] h-[51px] text-[15px] uppercase text-red-500 border rounded-full p-4 font-extrabold text-xl mt-10"
          routerLink="/user-cancel"
        >
          Cancelar
        </button>
        <button
          class="bg-red-500 w-[169px] h-[51px] text-[15px] uppercase text-white rounded-full p-4 font-extrabold text-xl mt-10 disabled:opacity-25"
          type="button"
          (click)="onSubmit()"
          [disabled]="!activationForm.valid"
        >
          Continuar
        </button>
      </div>
    }
  </div>
</app-portal-layout>
